import { DialogType } from '../../@types';
import { JackpotProduct } from '../../@types/api';
import { AdditionalQueryParams } from '../../hooks/usePagination';

// FILTERS
import FilterLiabilityMonitoring from '../organisms/FilterLiabilityMonitoring';
import FilterPlayers from '../organisms/forms/FilterPlayers';
import FilterPartners from '../organisms/forms/FilterPartners';
import FilterEvents from '../organisms/forms/FilterEvents';
import FilterPlayerReport from '../organisms/forms/FilterPlayerReport';
import FilterPreMatchSettingsForm from '../organisms/forms/FilterPreMatchSettingsData';
import FilterSportsbookReports from '../organisms/forms/FilterSportsbookReports';
import FilterTicketAuthorization from '../organisms/forms/FilterTicketAuthorization';
import FilterTicketMonitoring from '../organisms/forms/FilterTicketMonitoring';
import FilterWalletTransactions from '../organisms/forms/FilterWalletTransactions';
import FilterTotalCredit from '../organisms/forms/FilterTotalCredit';
import FilterPaymentReportsList from '../organisms/forms/FilterPaymentReportsList';
import FilterPaymentReportsTotal from '../organisms/forms/FilterPaymentReportsTotal';
import FilterDailyReports from '../organisms/FilterDailyReports';
import FilterAgentReport from '../organisms/FilterAgentsReports';
import FilterAffiliateReport from '../organisms/FilterAffiliatesReports';
import FilterManagersReport from '../organisms/FilterManagersReports';
import FilterJackpots from '../organisms/forms/FilterJackpots';
import FilterJackpotReports from '../organisms/forms/FilterJackpotReports';
import FilterOutrights from '../organisms/forms/FilterOutrights';
import FilterCashoutReports from '../organisms/forms/FilterCashoutReports';
import FilterBonuses from '../organisms/forms/FilterBonuses';
import FilterCashbackBonuses from '../organisms/forms/FilterCashbackBonuses';
import FilterWelcomeBonus from '../organisms/forms/FilterWelcomeBonus';
import FilterPublishEvents from '../organisms/forms/FilterPublishEvents';
import FilterBonusReports from '../organisms/forms/FilterBonusReports';
import FilterWelcomeBonusReports from '../organisms/forms/FilterWelcomeBonusReports';
import FilterResults from '../organisms/forms/FilterResults';
import FilterMarketplace from '../organisms/forms/FilterMarketplace';
import FilterCampaigns from '../organisms/forms/FilterCampaigns';
import FilterCampaignReports from '../organisms/forms/FilterCampaignReports';
import FilterApprovals from '../organisms/forms/FilterApprovals';
import FilterCasinoBets from '../organisms/forms/FilterCasinoBets';
import FilterCasinoGames from '../organisms/forms/FilterCasinoGames';
import FilterCasinoReports from '../organisms/forms/FilterCasinoReports';
import FilterCasinoTransactions from '../organisms/forms/FilterCasinoTransactions';
import FilterCasinoFreeSpins from '../organisms/forms/FilterCasinoFreeSpins';
import FilterGoldGamesFreeSpins from '../organisms/forms/FilterGoldGamesFreeSpins';

const filters = {
  events: FilterEvents,
  outrights: FilterOutrights,
  'jackpot-report': FilterJackpotReports,
  'sportsbook-report': FilterSportsbookReports,
  'payments-list': FilterPaymentReportsList,
  'payments-total': FilterPaymentReportsTotal,
  'player-report': FilterPlayerReport,
  'agents-report': FilterAgentReport,
  'affiliates-report': FilterAffiliateReport,
  'managers-report': FilterManagersReport,
  'publish-events': FilterPublishEvents,
  '*': FilterPreMatchSettingsForm,
  'ticket-monitoring': FilterTicketMonitoring,
  'ticket-authorization': FilterTicketAuthorization,
  'liability-monitoring': FilterLiabilityMonitoring,
  crm: FilterPlayers,
  partners: FilterPartners,
  'wallet-transaction': FilterWalletTransactions,
  'payment-transaction': FilterWalletTransactions,
  'total-credit': FilterTotalCredit,
  daily: FilterDailyReports,
  jackpot: FilterJackpots,
  'cashout-report': FilterCashoutReports,
  'cashback-bonus': FilterCashbackBonuses,
  'welcome-bonus': FilterWelcomeBonus,
  'num-of-selections-bonus': FilterBonuses,
  'bonus-reports': FilterBonusReports,
  'welcome-bonus-reports': FilterWelcomeBonusReports,
  results: FilterResults,
  marketplace: FilterMarketplace,
  campaigns: FilterCampaigns,
  'campaign-reports': FilterCampaignReports,
  approvals: FilterApprovals,
  'casino-games': FilterCasinoGames,
  'casino-transactions': FilterCasinoTransactions,
  'casino-free-spins': FilterCasinoFreeSpins,
  'gold-games-free-spins': FilterGoldGamesFreeSpins,
  'casino-bets': FilterCasinoBets,
  'casino-reports': FilterCasinoReports,
};

export type FilterTypes = keyof typeof filters;

export type FilterFeatureProps = {
  product?: JackpotProduct;
  statuses?: string[];
};

type Props = DialogType & {
  filter: FilterTypes;
  changeQuery?: (data: AdditionalQueryParams) => void;
  filterProps?: FilterFeatureProps;
};

const FilterModal = ({ filter, changeQuery, closeModal = () => void 0, filterProps }: Props) => {
  const FilterComponent = filters[filter];
  // @ts-expect-error
  return <FilterComponent {...filterProps} changeQuery={changeQuery} closeModal={closeModal} />;
};

export default FilterModal;
